<template>
  <dx-grid
    url="Alumini"
    :columns="columns"
    :title="title"
    :onRowClicked="onRowClicked"
    navigationPath="onRowClicked"
    navigationField="onRowClicked"
  ></dx-grid>
</template>

<script>
//import { formatCurrency } from "../utils/helpers.js";
export default {
  data: () => ({
    title: "Alumini",
    columns: [
      {
        field: "isMappedIcon",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
          width: undefined,
        },
        icon: (value, row) => {
          return value ? "mdi-check-circle" : "mdi-alert";
        },
        iconColor: (value, row) => {
          return value ? "success" : "#f35123";
        },
      },
      {
        field: "firstHebrew",
        label: "First Hebrew",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "lastHebrew",
        label: "Last Hebrew",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "engName",
        label: "First English",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "lastEnglish",
        label: "Last English",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "regID",
        label: "Last Term",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "isMapped",
        label: "Is Mapped",
        format: "",
        type: "boolean",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "class",
        label: "Class",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "section",
        label: "Section",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "branch",
        label: "Branch",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "familyID",
        label: "Family ID",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "studentID",
        label: "Student ID",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "fatherPersonID",
        label: "Father Person ID",
        link: "DinnerAccountView",
        format: "",
        template: "link-cell-template",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "weddingYear",
        label: "Wedding Year",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "DOB",
        field: "dob",
        type: "date",
        format: "MM/dd/yyyy",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "fatherInLaw",
        label: "Mapped To Father In Law",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "father",
        label: "Mapped To Father",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Mapped To Person ID",
        field: "mappedToPersonID",
        link: "DinnerAccountView",
        format: "",
        template: "link-cell-template",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Mapped To Name",
        field: "mappedToName",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Mapped To Hebrew Name",
        field: "mappedToNameH",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "type",
        label: "Mapped To Type",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "address1",
        label: "Mapped To Address",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Mapped To Home Phone",
        field: "mappedToHomePhone",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  methods: {
    onRowClicked(row) {
      this.$router.push({
        name: "DinnerAccountView",
        params: {
          id: row.fatherPersonID,
        },
        query: {
          aluminiStudent: row.studentID,
          limitView: true,
        },
      });
    },
  },
};
</script>
<style></style>
